import { useState } from "react";

/**
 * Hook for managing scan results state
 */
export const useScanResultsState = () => {
  const [scanResults, setScanResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [expandedTables, setExpandedTables] = useState({});
  const [previewTables, setPreviewTables] = useState({});
  const [distributionFilter, setDistributionFilter] = useState("all");
  const [selectedPiiColumns, setSelectedPiiColumns] = useState({});

  const getSelectedColumnsCount = () => {
    return Object.values(selectedPiiColumns).filter(Boolean).length;
  };

  const handleSelectAllColumns = (tableName = null) => {
    const newSelection = { ...selectedPiiColumns };

    if (scanResults?.summary) {
      const targetResults = tableName
        ? scanResults.results.filter((r) => r.table_name === tableName)
        : scanResults.results;

      targetResults.forEach((result) => {
        result.pii_columns?.forEach((col) => {
          const key = `${result.table_name}|||${col.column_name}`;
          newSelection[key] = true;
        });
      });
    } else {
      scanResults?.pii_columns?.forEach((col) => {
        const key = `${scanResults.table_name}|||${col.column_name}`;
        newSelection[key] = true;
      });
    }

    setSelectedPiiColumns(newSelection);
  };

  const handleDeselectAllColumns = () => {
    setSelectedPiiColumns({});
  };

  const handleColumnCheckboxChange = (tableName, columnName) => {
    const key = `${tableName}|||${columnName}`;
    setSelectedPiiColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return {
    scanResults,
    setScanResults,
    loading,
    setLoading,
    expandedTables,
    setExpandedTables,
    previewTables,
    setPreviewTables,
    distributionFilter,
    setDistributionFilter,
    selectedPiiColumns,
    setSelectedPiiColumns,
    getSelectedColumnsCount,
    handleSelectAllColumns,
    handleDeselectAllColumns,
    handleColumnCheckboxChange,
  };
};
